module.exports = __webpack_public_path__ + "static/media/fe_drop-down.cfdf9855.svg";